import { Routes, Route } from "react-router-dom";
import MainLayout from "@/components/layout/MainLayout";
import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { API } from "@/App";
import axios from "axios";
import { toast } from "sonner";
import { ClipboardList, FolderOpen, FileText, TrendingUp, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

function DashboardHome() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/dashboard/stats`);
      setStats(response.data);
    } catch (error) {
      toast.error("Erro ao carregar estatísticas");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-luvcorp-navy"></div>
      </div>
    );
  }

  return (
    <div className="space-y-8" data-testid="engineering-dashboard">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card className="border-0 shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-slate-500 mb-1">Projetos</p>
                <p className="text-3xl font-bold text-luvcorp-navy">{stats?.total_projects || 0}</p>
              </div>
              <div className="h-12 w-12 bg-luvcorp-navy/10 rounded-lg flex items-center justify-center">
                <FolderOpen className="h-6 w-6 text-luvcorp-navy" />
              </div>
            </div>
            <Link to="/projects" className="flex items-center gap-1 text-sm text-luvcorp-gold mt-4 hover:underline">
              Ver projetos <ArrowUpRight className="h-4 w-4" />
            </Link>
          </CardContent>
        </Card>

        <Card className="border-0 shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-slate-500 mb-1">Ordens de Serviço</p>
                <p className="text-3xl font-bold text-luvcorp-navy">{stats?.total_service_orders || 0}</p>
              </div>
              <div className="h-12 w-12 bg-luvcorp-gold/10 rounded-lg flex items-center justify-center">
                <ClipboardList className="h-6 w-6 text-luvcorp-gold" />
              </div>
            </div>
            <Link to="/service-orders" className="flex items-center gap-1 text-sm text-luvcorp-gold mt-4 hover:underline">
              Ver ordens <ArrowUpRight className="h-4 w-4" />
            </Link>
          </CardContent>
        </Card>

        <Card className="border-0 shadow-sm hover:shadow-md transition-shadow">
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-slate-500 mb-1">Registros Diários</p>
                <p className="text-3xl font-bold text-luvcorp-navy">{stats?.total_daily_logs || 0}</p>
              </div>
              <div className="h-12 w-12 bg-emerald-100 rounded-lg flex items-center justify-center">
                <FileText className="h-6 w-6 text-emerald-600" />
              </div>
            </div>
            <Link to="/daily-logs" className="flex items-center gap-1 text-sm text-luvcorp-gold mt-4 hover:underline">
              Ver diários <ArrowUpRight className="h-4 w-4" />
            </Link>
          </CardContent>
        </Card>
      </div>

      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle className="text-lg font-heading flex items-center gap-2">
            <TrendingUp className="h-5 w-5 text-luvcorp-gold" />
            Acesso Rápido
          </CardTitle>
        </CardHeader>
        <CardContent className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Link to="/kanban" className="p-4 border rounded-lg hover:border-luvcorp-gold hover:bg-luvcorp-gold/5 transition-colors text-center">
            <TrendingUp className="h-8 w-8 mx-auto mb-2 text-luvcorp-navy" />
            <p className="text-sm font-medium">Kanban</p>
          </Link>
          <Link to="/service-orders/new" className="p-4 border rounded-lg hover:border-luvcorp-gold hover:bg-luvcorp-gold/5 transition-colors text-center">
            <ClipboardList className="h-8 w-8 mx-auto mb-2 text-luvcorp-navy" />
            <p className="text-sm font-medium">Nova OS</p>
          </Link>
          <Link to="/daily-logs/new" className="p-4 border rounded-lg hover:border-luvcorp-gold hover:bg-luvcorp-gold/5 transition-colors text-center">
            <FileText className="h-8 w-8 mx-auto mb-2 text-luvcorp-navy" />
            <p className="text-sm font-medium">Novo RDO</p>
          </Link>
          <Link to="/financial" className="p-4 border rounded-lg hover:border-luvcorp-gold hover:bg-luvcorp-gold/5 transition-colors text-center">
            <FolderOpen className="h-8 w-8 mx-auto mb-2 text-luvcorp-navy" />
            <p className="text-sm font-medium">Financeiro</p>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}

export default function EngineeringDashboard() {
  return (
    <MainLayout>
      <Routes>
        <Route index element={<DashboardHome />} />
      </Routes>
    </MainLayout>
  );
}
